import {
    Box,
    Flex,
    HStack,
    Text,
    VStack,
} from "@chakra-ui/react";

import Card from "../../Dashboard/components/Card";

const GrowthChart = ({
    drivers = [],
}) => {
    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    const currentYear =
        new Date().getFullYear();

    const data = monthNames.map(
        (
            month,
            index
        ) => {
            const registrations =
                drivers.filter(
                    driver => {
                        const date =
                            new Date(
                                driver.created_at
                            );

                        return (
                            date.getMonth() ===
                                index &&
                            date.getFullYear() ===
                                currentYear
                        );
                    }
                ).length;

            const active =
                drivers.filter(
                    driver => {
                        const date =
                            new Date(
                                driver.created_at
                            );

                        return (
                            date.getMonth() ===
                                index &&
                            date.getFullYear() ===
                                currentYear &&
                            driver.driver
                                ?.status ===
                                "Approved"
                        );
                    }
                ).length;

            return {
                month,
                registrations,
                active,
            };
        }
    );

    const max =
        Math.max(
            ...data.map(
                d =>
                    d.registrations
            ),
            1
        );

    return (
        <Card h="100%">
            <Flex
                justify="space-between"
                align="center"
                mb={8}
                flexWrap="wrap"
                gap={4}
            >
                <Text
                    fontSize="2xl"
                    fontWeight="700"
                    color="#071D54"
                >
                    Monthly Driver Growth
                </Text>

                <HStack gap={6}>
                    <HStack>
                        <Box
                            w="12px"
                            h="12px"
                            borderRadius="full"
                            bg="#2453FF"
                        />

                        <Text fontSize="sm">
                            New Registrations
                        </Text>
                    </HStack>

                    <HStack>
                        <Box
                            w="12px"
                            h="12px"
                            borderRadius="full"
                            bg="#C9D8FF"
                        />

                        <Text fontSize="sm">
                            Approved Drivers
                        </Text>
                    </HStack>
                </HStack>
            </Flex>
<Box overflowX="auto">
    <Flex
        h={{
            base: "280px",
            md: "360px",
        }}
        align="end"
        gap={{
            base: 3,
            md: 4,
        }}
        minW={{
            base: "720px",
            lg: "100%",
        }}
    >
                {data.map(
                    item => {
                        const totalHeight =
                            (item.registrations /
                                max) *
                            280;

                        const activeHeight =
                            item.registrations >
                            0
                                ? (
                                      item.active /
                                      item.registrations
                                  ) *
                                  totalHeight
                                : 0;

                        return (
                            <VStack
                                key={
                                    item.month
                                }
                                flex="1"
                                justify="end"
                                h="100%"
                                gap={3}
                            >
                                <Text
                                    fontSize="xs"
                                    color="gray.500"
                                >
                                    {
                                        item.registrations
                                    }
                                </Text>

                                <Flex
                                    direction="column"
                                    justify="end"
                                    h="300px"
                                    w="100%"
                                    borderRadius="10px 10px 0 0"
                                    overflow="hidden"
                                >
                                    <Box
                                        h={`${activeHeight}px`}
                                        bg="#2453FF"
                                    />

                                    <Box
                                        h={`${
                                            totalHeight -
                                            activeHeight
                                        }px`}
                                        bg="#C9D8FF"
                                    />
                                </Flex>

                                <Text
                                    fontSize="sm"
                                    color="gray.500"
                                    textTransform="uppercase"
                                >
                                    {
                                        item.month
                                    }
                                </Text>
                            </VStack>
                        );
                    }
                )}
            </Flex>
            </Box>
        </Card>
    );
};

export default GrowthChart;